export default "__VITE_PUBLIC_ASSET__527c9328__"